import { Module } from "./Module";
import { NeoTypes } from '.';
import { ConfigService } from './Config/ConfigService';
import { NotificationStore } from '../Components/Notifications/NotificationStore';
import { TaskRunner, NotifyUtils } from '../';
import ModalStore from '../Components/Modal/ModalStore';
import { MenuItemProvider } from '../Routing/MenuItemProvider';
import { ErrorHandler } from '../Components/ErrorHandler';
import { ConnectionManager } from '../ConnectionManager';
import LocalisationService from '../Localisation/LocalisationService';
import { NotificationHelper } from '../Components/Notifications/NotificationHelper';
import { RouteSecurityService } from "../Routing/RouteSecurityService";
import { NeoLoginErrorHandler } from "../Security/LoginErrorHandler";
import { SecurityService } from "../Security/SecurityService";
var neoModule = new Module("neo", function (container) {
    container.bind(NeoTypes.Config.ConfigService).to(ConfigService).inSingletonScope();
    container.bind(NeoTypes.Core.ConnectionManager).to(ConnectionManager).inSingletonScope();
    container.bind(NeoTypes.Routing.MenuItemProvider).to(MenuItemProvider).inSingletonScope();
    container.bind(NeoTypes.Routing.RouteSecurityService).to(RouteSecurityService).inSingletonScope();
    container.bind(NeoTypes.Security.LoginErrorHandler).to(NeoLoginErrorHandler).inSingletonScope();
    container.bind(NeoTypes.Security.SecurityService).to(SecurityService).inSingletonScope();
    container.bind(NeoTypes.Localisation.LocalisationService).to(LocalisationService).inSingletonScope();
    container.bind(NeoTypes.UI.ModalStore).to(ModalStore).inSingletonScope();
    container.bind(NeoTypes.UI.NotificationStore).to(NotificationStore).inTransientScope();
    container.bind(NeoTypes.UI.NotificationHelper).to(NotificationHelper).inTransientScope();
    container.bind(NeoTypes.UI.ErrorHandler).to(ErrorHandler).inSingletonScope();
    container.bind(NeoTypes.UI.GlobalNotifications).toConstantValue(NotifyUtils);
    container.bind(NeoTypes.TaskRunner).to(TaskRunner).inTransientScope();
});
export default neoModule;
